import request from '@/utils/request'
// import qs from 'qs'

// export function getListDailyReport(query) {
//   return request({
//     url: '/report-service/v1/report/daily-report',
//     method: 'get',
//     params: query,
//     paramsSerializer: query => {
//       return qs.stringify(query, {
//         arrayFormat: 'repeat',
//         encode: false
//       })
//     }
//   })
// }

export function getCardRoomByBookingId(bookingId) {
  return request({
    url: '/card-service/v1/card-room/detail',
    method: 'get',
    params: {
      bookingId
    }
  })
}

export function getCardRoomByCardNumber(cardNum) {
  return request({
    url: '/card-service/v1/card-room/by-card-number',
    method: 'get',
    params: { cardNumber: cardNum }
  })
}

export function deleteCardRoom(roomId, cardNumber) {
  return request({
    url: '/card-service/v1/card-room',
    method: 'delete',
    params: {
      roomId,
      cardNumber
    }
  })
}

export function cacheCardsToRoom(data) {
  return request({
    url: '/card-service/v1/card-room',
    method: 'post',
    data
  })
}
// for update card-room after check-in => no need to use (intead use below and above api!)
export function executeCardRoomForUpdate(data) {
  return request({
    url: '/card-service/v1/card-room/execute',
    method: 'post',
    data
  })
}

// for check-in
export function executeCardRoomForCheckin(data) {
  return request({
    url: '/card-service/v1/card-room/execute-multiple',
    method: 'post',
    data
  })
}
// for check-out
export function executeCardRoomForCheckout(data) {
  return request({
    url: '/card-service/v1/card-room/delete-multiple-by-bookingid',
    method: 'delete',
    data
  })
}

// ===================== Assign Card Room ======================= //
export function assignUserToRoom(data, params) {
  return request({
    url: '/card-service/v1/card-room/with-filter',
    method: 'post',
    data,
    params
  })
}
export function updateCardForStaff(params) {
  return request({
    url: '/card-service/v1/card-room/for-staff',
    method: 'put',
    params
  })
}
export function executeCardRoomBeforeDeleteAccount(data) {
  return request({
    url: '/card-service/v1/card-room/delete-multiple-by-cardnumber',
    method: 'delete',
    data
  })
}
export function updateCardPeriod(params) {
  return request({
    url: '/card-service/v1/card-room/update-period-card',
    method: 'put',
    params
  })
}
